import { useState, useEffect } from 'react';
import type { Template } from '@flashcard/shared';
import { api } from '../lib/api';

export function AdminTemplatesPage() {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', description: '', productUid: '', file: null as File | null });

  useEffect(() => {
    fetchTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchTemplates = async () => {
    setLoading(true);
    setError(null);
    try {
      setTemplates(await api.getTemplates());
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append('name', formData.name);
    fd.append('description', formData.description || '');
    fd.append('productUid', formData.productUid);
    fd.append('isActive', 'true');
    if (formData.file) fd.append('file', formData.file);

    try {
      const res = await fetch('/api/templates', { method: 'POST', body: fd });
      if (res.ok) {
        setShowForm(false);
        setFormData({ name: '', description: '', productUid: '', file: null });
        await fetchTemplates();
      } else {
        setError('Fehler beim Erstellen des Templates');
      }
    } catch {
      setError('Fehler beim Erstellen des Templates');
    }
  };

  return (
    <div>
      <h2>Admin: Templates verwalten</h2>
      <p style={{ marginBottom: '1rem' }}>
        <em>Platzhalter – später mit Auth schützen</em>
      </p>

      <button className="btn btn-secondary" onClick={() => setShowForm(!showForm)} style={{ marginBottom: '1rem' }}>
        {showForm ? 'Formular verstecken' : 'Neues Template anlegen'}
      </button>

      {showForm && (
        <form className="card" onSubmit={handleSubmit} style={{ marginBottom: '2rem' }}>
          <div className="form-group">
            <label>Name *</label>
            <input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Beschreibung</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              rows={3}
            />
          </div>
          <div className="form-group">
            <label>Product UID *</label>
            <input
              value={formData.productUid}
              onChange={(e) => setFormData({ ...formData, productUid: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>Preview-Bild / PDF *</label>
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={(e) => setFormData({ ...formData, file: e.target.files![0] })}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">
            Speichern
          </button>
        </form>
      )}

      {loading && <p>Lade Templates…</p>}
      {error && <p className="error">{error}</p>}

      {!loading && !error && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem' }}>
          {templates.map((t) => (
            <div key={t.id} className="card">
              {t.previewUrl && (
                <img
                  src={t.previewUrl}
                  alt={t.name}
                  style={{ width: '100%', height: '140px', objectFit: 'cover', marginBottom: '0.5rem' }}
                />
              )}
              <strong>{t.name}</strong>
              <br />
              <small>{t.productUid}</small>
              <div style={{ marginTop: '0.5rem' }}>
                <span className={t.isActive ? 'success' : 'error'}>{t.isActive ? 'Aktiv' : 'Inaktiv'}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
